import { FC, memo, useMemo } from "react";

import { useTheme } from "@mui/material";
import { sanitizeRichTextDescription } from "@simplyk/common";

import {
  deserialize,
  getRichTextInputLinkStyles,
  getRichTextInputTextStyles,
  // eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
} from "@/dashboard-design-system/RichTextInput/helpers";
import { FormExpandableText } from "@/forms-design-system/FormExpandableText";

interface PrizeDescriptionProps {
  description: string;
}

export const PrizeDescription: FC<PrizeDescriptionProps> = memo(({ description }) => {
  const { isLexicalRichText: isRichDescription, value: parsedDescription } = useMemo(
    () => deserialize(description),
    [description]
  );
  const sanitizedDescription = useMemo(() => sanitizeRichTextDescription(parsedDescription) ?? "", [parsedDescription]);
  const theme = useTheme();

  return (
    <FormExpandableText
      gradientOverlayHeight="20px"
      gradientOverlayColor={theme.palette.forms.surface.intense}
      isInitiallyExpanded
      maxHeight="none"
      sx={{
        ...(isRichDescription && {
          ...getRichTextInputTextStyles(theme),
          ...getRichTextInputLinkStyles(theme.palette.forms.text.brand),
        }),
      }}
    >
      {sanitizedDescription}
    </FormExpandableText>
  );
});

PrizeDescription.displayName = "PrizeDescription";
